import clsx from 'clsx';
import { Trans } from '@lingui/react/macro';
import logoImg from '../../assets/img/logo.svg';

interface GuestSidebarProps {
  className?: string;
}

function GuestSidebar({ className }: GuestSidebarProps) {
  return (
    <aside
      className={clsx(
        'fixed top-0 left-0 flex h-full flex-col border-r border-gray-200 bg-white px-12 py-6',
        className,
      )}
    >
      {/* Logo/Branding */}
      <div className="mb-8">
        <a href="/">
          <img src={logoImg} alt="Instapaper" width={126} />
        </a>
      </div>

      {/* Auth Links */}
      <nav className="flex flex-col gap-1">
        <a href="/user/register" className="menu-item">
          <Trans>Create Account</Trans>
        </a>
        <a href="/user/login" className="menu-item">
          <Trans>Sign In</Trans>
        </a>
      </nav>
    </aside>
  );
}

export default GuestSidebar;
